import React, { useRef } from 'react';
import { Favorite } from '@yme/assets/icons';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { Tooltip } from '@yme/atoms/tooltip';
import { useWindowSize } from '@yme/hooks/index';
import { API } from '@yme/hooks/useWishlist/api';
import useAdjustFavButtonPosition from '@yme/molecules/cards/favorite-card-button/hooks';
import { useTranslation } from '@yme/services/i18n';
import { FavoriteButton } from './styled';
export function FavoriteCardButton({ onLike, isLiked, fitTo }) {
    const { width, isMobileView } = useWindowSize();
    const { t } = useTranslation();
    const favButtonRef = useRef(null);
    const targetSKU = useRef(undefined);
    const isBusy = API.pendingItems.has(targetSKU.current ?? '');
    const internalIsLiked = isLiked ?? false;
    const title = isLiked
        ? t('wishlist_buttonTooltipToRemoveItem_label')
        : t('wishlist_buttonTooltipToAddItem_label');
    useAdjustFavButtonPosition({
        favButtonRef,
        width,
        fitTo,
    });
    if (!onLike) {
        return null;
    }
    const internalOnClick = () => (e) => {
        targetSKU.current = onLike(e);
    };
    return isMobileView ? (React.createElement(FavoriteButton, { type: "button", title: title, onClick: internalOnClick(), isLiked: internalIsLiked, isBusy: isBusy, ref: favButtonRef },
        React.createElement(SVGIcon, { type: Favorite }))) : (React.createElement(Tooltip, { title: title },
        React.createElement(FavoriteButton, { type: "button", onClick: internalOnClick(), isLiked: isLiked ?? false, isBusy: isBusy, ref: favButtonRef },
            React.createElement(SVGIcon, { type: Favorite }))));
}
